<template>
  <div class="user-center">
    <div class="user-center-aside-menu">
      <el-menu router :default-active="defaultActive">
        <el-menu-item
          :index="menuItem.pathName"
          v-for="(menuItem, index) in menuList"
          :key="index"
        >
          <span slot="title">{{ menuItem.menuLable }}</span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="user-center-main-cont">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuList: [
        {
          pathName: "/user-center/my-delivered-resume",
          menuLable: "我投递的职位"
        },
        {
          pathName: "/user-center/will-optimized-resume",
          menuLable: "待优化的简历"
        },
        {
          pathName: "/user-center/collection-resume",
          menuLable: "我收藏的职位"
        },
        {
          pathName: "/user-center/change-password",
          menuLable: "修改密码"
        },
        {
          pathName: "/user-center/binging-account",
          menuLable: "绑定账户"
        }
      ]
    };
  },

  computed: {
    defaultActive() {
      return this.$route.path;
    }
  }
};
</script>

<style lang="scss">
.user-center {
  width: 1200px;
  margin: auto;
  padding-top: 20px;
  display: flex;
  &-aside-menu {
    width: 200px;
    .el-menu-item {
      &:focus,
      &:hover {
        background-color: #ffffff;
        color: #2675E6;
      }
      &.is-active {
        span {
          position: relative;
          color: #246FD9;
          font-weight: 600;
          &::before {
            content: "";
            display: block;
            position: absolute;
            top: 0;
            left: -20px;
            width: 2px;
            height: 100%;
            background-color:  #246FD9;
          }
        }
      }
    }
  }
  &-main-cont {
    flex: 1;
    padding-left: 20px;
  }
}
</style>
